import { useNavigate } from "react-router-dom";
import { Login } from "../../pages/Login";
import { useAuth } from "./useAuth";
import { Privilegio } from "./types";
import { AcessoRestrito } from "../../pages/AcessoRestrito";
import React from "react";

export const RequireAuth = ({ children }: { children: React.JSX.Element }) => {
    const auth = useAuth();
    const navigate = useNavigate();

    if (!auth.usunome) {
        navigate('/')
        return <Login />
    }

    return children;
}

export const RequireAuthGestao = ({ children }: { children: React.JSX.Element }) => {
    const auth = useAuth();
    const navigate = useNavigate();

    if (!auth.token) {
        navigate('/login')
        return <Login />
    } else if (auth.privilegio === Privilegio.Normal) {
        return <AcessoRestrito />
    }

    return children;
}

export const RequireAuthAdm = ({ children }: { children: React.JSX.Element }) => {
    const auth = useAuth();
    const navigate = useNavigate();

    if (!auth.token) {
        navigate('/login')
        return <Login />
    } else if (auth.privilegio !== Privilegio.Admnistrador) {
        return <AcessoRestrito />
    }

    return children;
}